
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Database } from "@/integrations/supabase/types";

type Entry = Database["public"]["Tables"]["entries"]["Row"];

type EntrySpotlightProps = {
  entry: Entry;
  stripHtmlTags: (html: string | null) => string;
};

export const EntrySpotlight = ({ entry, stripHtmlTags }: EntrySpotlightProps) => {
  return (
    <div className="mt-10">
      <h2 className="text-xl font-semibold mb-4 flex items-center">
        <div className="mr-2">✨</div>
        Entry Spotlight
      </h2>
      <Card className="border-dashed">
        <CardHeader>
          <CardTitle>{entry.title}</CardTitle>
          <div className="flex flex-wrap gap-1 my-1">
            <Badge variant="outline">
              {entry.entry_type}
            </Badge>
          </div>
        </CardHeader>
        <CardContent>
          <p className="line-clamp-3">
            {stripHtmlTags(entry.content) || "No content"}
          </p>
        </CardContent>
        <CardFooter className="border-t pt-4">
          <Link to={`/dashboard/entry/${entry.id}`}>
            <Button>Read More</Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
};
